import React from 'react';
import classes from './InputWithLabel.module.css';

const InputWithLabel = ({
  defaultValue,
  onChange,
  className,
  placeholder,
  onBlur,
  label,
  postfixClass,
  postfix = null,
  prefix = null,
  isInvalid,
  isRequired,
  maxLength,
  labelClassName
}) => {
  return (
    <div className={classes['form-input-container']}>
      {isRequired ? <span className={classes.asterisk}>*</span> : null}
      {label ? (
        <span className={`${classes.label} ${labelClassName}`}>{label}</span>
      ) : null}

      {prefix ? <span>{prefix}</span> : null}
      <input
        placeholder={placeholder}
        className={`${classes['form-input']} ${className} ${
          isInvalid ? classes.invalid : ''
        }`}
        defaultValue={defaultValue}
        onChange={e => onChange(e.target.value)}
        onBlur={e => onBlur && onBlur(e.target.value)}
        maxLength={maxLength}
      />
      {postfix ? <span className={`${postfixClass}`}>{postfix}</span> : null}
    </div>
  );
};

export default InputWithLabel;
